import React from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import AboutSection from '../Section/AboutSection';
import Section from '../Section';
import DepartmentSectionStyle2 from '../Section/DepartmentSection/DepartmentSectionStyle2';
import FeaturesSectionStyle2 from '../Section/FeaturesSection/FeaturesSectionStyle2';
import FunFactSection from '../Section/FunFactSection';
// import GallerySection from '../Section/GallerySection';
import { pageTitle } from '../../helpers/PageTitle';
import ReactCountryFlag from "react-country-flag";

  const regions = [
    {
      name: "Europe",
      icon: <ReactCountryFlag
        countryCode="EU"
        svg
        style={{ width: "1.8em", height: "1.8em" }}
      />,
    },
    {
      name: "Australia",
      icon: <ReactCountryFlag
        countryCode="AU"
        svg
        style={{ width: "1.8em", height: "1.8em" }}
      />,
    },
    {
      name: "Canada",
      icon: <ReactCountryFlag
        countryCode="CA"
        svg
        style={{ width: "1.8em", height: "1.8em" }}
      />,
    },
     {
      name: "India",
      icon: <ReactCountryFlag
        countryCode="IN"
        svg
        style={{ width: "1.8em", height: "1.8em" }}
      />,
    },
     {
      name: "Lebanon",
      icon: <ReactCountryFlag
        countryCode="LB"
        svg
        style={{ width: "1.8em", height: "1.8em" }}
      />,
    },
  ];
const departmentData = [
  {
    title: 'Clear Aligner Treatment Planning',
    subTitle:
      '',
    iconUrl: '/images/icons/teeth.svg',
    href: '/services/clear-aligner-treatment-planning',
  },
  {
    title: 'Orthodontic CAD Design Services',
    subTitle:
      '',
    iconUrl: '/images/icons/teeth.svg',
    href: '/services/orthodontic-cad-design-services',
  },
  {
    title: 'Fixed and Removable Retainer Design',
    subTitle:
      '',
    iconUrl: '/images/icons/teeth.svg',
    href: '/services/fixed-and-removable-retainer-design',
  },
  {
    title: 'Sleep Apnea & MAD Device Design',
    subTitle:
      '',
    iconUrl: '/images/icons/teeth.svg',
    href: '/services/sleep-apnea-mad-device-design',
  },
  {
    title: 'Surgical Guide Design for Implantology',
    subTitle:
      '',
    iconUrl: '/images/icons/teeth.svg',
    href: '/services/surgical-guide-design-for-implantology',
  },
  {
    title: 'Digital Model Analysis and Setup',
    subTitle:
      '',
    iconUrl: '/images/icons/teeth.svg',
    href: '/services/digital-model-analysis-and-setup',
  },
  // {
  //   title: '3D Orthodontic Treatment Simulation',
  //   subTitle:
  //     '',
  //   iconUrl: '/images/icons/teeth.svg',
  //   href: '/services/3d-orthodontic-treatment-simulation',
  // },
  {
    title: 'CAD/CAM Workflow Consultation',
    subTitle:
      '',
    iconUrl: '/images/icons/teeth.svg',
    href: '/services/cad-cam-workflow-consultation',
  },
];

const featureListData = [
  {
    title: 'Engineering Precision in Every Design',
    subTitle:
      'We combine advanced CAD/CAM technology with orthodontic expertise to deliver highly accurate digital designs that ensure exceptional fit, functionality, and treatment outcomes.',
    iconUrl: 'images/icons/professional.svg',
  },
  {
    title: 'Complete Digital Orthodontic Solutions',
    subTitle:
      'From clear aligner treatment planning and retainers to surgical guides, sleep apnea devices, and digital model analysis, we provide comprehensive CAD solutions under one roof.',
    iconUrl: 'images/icons/comprehensive.svg',
  },
  {
    title: 'Fast, Reliable & Workflow-Focused',
    subTitle:
      'Our optimized digital workflows help orthodontists, dental laboratories, and aligner manufacturers reduce turnaround times, improve efficiency, and streamline clinical operations.',
    iconUrl: 'images/icons/patient.svg',
  },
  {
    title: 'Trusted Global Partner',
    subTitle:
      'We collaborate with dental professionals and organizations worldwide, delivering reliable, patient-focused orthodontic solutions backed by innovation, consistency, and uncompromising quality.',
    iconUrl: 'images/icons/facilities.svg',
  },
];
const howWeWorkVideos = [
  {
    title: "Digital Case Submission",
    videoUrl: "/images/gallery/1.mp4",
    thumbnail: "/images/videos/thumb1.jpg",
  },
  {
    title: "Treatment Planning",
    videoUrl: "/images/gallery/2.mp4",
    thumbnail: "/images/videos/thumb2.jpg",
  },
  {
    title: "3D CAD Design",
    videoUrl: "/images/gallery/3.mp4",
    thumbnail: "/images/videos/thumb3.jpg",
  },
  {
    title: "Quality Check",
    videoUrl: "/images/gallery/4.mp4",
    thumbnail: "/images/videos/thumb4.jpg",
  },
  {
    title: "Manufacturing Support",
    videoUrl: "/images/gallery/5.mp4",
    thumbnail: "/images/videos/thumb5.jpg",
  },
  {
    title: "Final Delivery",
    videoUrl: "/images/gallery/6.mp4",
    thumbnail: "/images/videos/thumb6.jpg",
  },
];
const funFactData = [
  { number: '6+', title: 'Years of experience' },
  { number: '2020', title: 'Year Established ' },
  { number: '95%', title: 'Patient satisfaction rating' },
  { number: '5000+', title: 'Patients served annually' },
  // { number: '10+', title: 'Healthcare providers on staff' },
  // { number: '22+', title: 'Convenient locations in the area' },
];



export default function About() {
  pageTitle('About');
  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.svg"
        imgUrl="/images/about/banner_img.png"
        title="Welcome to <br />Precision Ortho CAD"
        subTitle="Precision in Design. Excellence in Orthodontics."
      />
      <Section topMd={100}>
              <AboutSection
                imgUrl="/images/home_1/about.png"
                imgUrl2="/images/home_1/aboutus2.png"
                spiningImgUrl="/images/home_1/about_mini.svg"
                title="About Us"
               featureList={[
                  {
                    featureListTitle: '',
                    featureListSubTitle: `Precision Ortho CAD is redefining orthodontic treatment through cutting-edge digital design solutions. Our expertise is unparalleled in crafting custom orthodontic appliances, clear aligner treatment plans, retainers, surgical guides, Sleep Apnea devices, and a variety of CAD/CAM-based dental innovations.

                With a robust foundation in engineering and dental technology, we seamlessly connect clinical needs with state-of-the-art digital manufacturing. Our dedicated team prioritizes precision, efficiency, and patient-focused outcomes, ensuring that each design exceeds the highest standards of quality and functionality.
                
                We partner with orthodontists, dentists, dental laboratories, and aligner companies worldwide, empowering them to optimize workflows, accelerate turnaround times, and achieve exceptional treatment results. By harnessing the latest advancements in digital technologies and sophisticated software platforms, Precision Ortho CAD boldly advances the future of orthodontic design.`,
                  },
                ]}
              />
            </Section>
      <Section topMd={200} topLg={150} topXl={110}>
        <DepartmentSectionStyle2
          sectionTitle="Provides Our Best Services"
          sectionTitleUp="SERVICES"
          data={departmentData}
        />
      </Section>
      <Section topMd={175} topLg={125} topXl={85} bottomMd={100} bottomLg={110}>
        <FeaturesSectionStyle2
          sectionTitle="Why Choose Us"
          imgUrl="images/about/whychooseus.png"
          data={featureListData}
        />
      </Section>
      <Section topMd={105} topLg={140} topXl={100} bottomMd={185} bottomLg={140} bottomXl={100}>
        <FunFactSection
          bgUrl="images/about/fun_fact_bg.jpeg"
          data={funFactData}
        />
      </Section>
      <Section data-aos="fade-up"
  data-aos-duration="1200"
  data-aos-offset="200">
              <section className="cs_how_we_work">
        <div className="container">
          <h2 className='text-center'>How We Work</h2>


          <div className="row g-4">
            {howWeWorkVideos.map((video, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="video-card">
                  <video
                    className="w-100 rounded"
                    controls
                    autoPlay
                    muted
                    loop
                    playsInline
                    poster={video.thumbnail}
                  >
                    <source src={video.videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>

                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      </Section>
      
      <Section className="trusted-by" data-aos="fade-up"
  data-aos-duration="1200"
  data-aos-offset="200">
          <div className="container">
            <h2>Trusted By</h2>

            <div className="trusted-grid">
              {regions.map((item, index) => (
                <div className="trusted-card" key={index}>
                  <div className="icon">{item.icon}</div>
                  <h4>{item.name}</h4>
                </div>
              ))}
            </div>
          </div>
        </Section>
      
      <Section className="cs_footer_margin_0" data-aos="fade-up"
  data-aos-duration="1200"
  data-aos-offset="200">
        <BannerSectionStyle4
          bgUrl="images/about/footerbanner.png"
          title="Don’t Let Your Smile <br />Take a Backseat!"
          subTitle="Schedule a case with our experienced dental <br /> professionals today!"
          center
        />
      </Section>
    </>
  );
}
